<template>
  <button
    type="button"
    class="fc-nav-actions__ask-noa"
    :data-testid="testId"
    @click="$emit('click')"
  >
    <span class="fc-nav-actions__ask-noa-icon-wrap">
      <img
        :data-testid="`${testId}-icon`"
        src="/img/navicon/fbc-nav/AskNoa.svg"
        alt=""
        class="fc-nav-actions__ask-noa-icon"
      />
    </span>
    <span class="fc-nav-actions__ask-noa-label">Ask Noa</span>
  </button>
</template>

<script>
export default {
  name: 'AskNoaButton',

  props: {
    testId: {
      type: String,
      required: true,
    },
  },

  emits: ['click'],
};
</script>
